var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.369 111.526C131.871 90.9947 131.871 57.7067 111.369 37.1754C90.8664 16.644 57.6254 16.644 37.123 37.1754C16.6205 57.7067 16.6205 90.9947 37.123 111.526C57.6254 132.057 90.8664 132.057 111.369 111.526Z",
    stroke: "#A6AAC4",
    strokeWidth: 4.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8784 62.1193C45.8784 59.5219 47.9355 57.4619 50.5292 57.4619C53.1229 57.4619 55.18 59.5219 55.18 62.1193C55.18 64.7166 53.1229 66.7766 50.5292 66.7766C47.9355 66.7766 45.8784 64.7166 45.8784 62.1193Z",
    fill: "#A6AAC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1914 62.1193C93.1914 59.5219 95.2485 57.4619 97.8422 57.4619C100.436 57.4619 102.493 59.5219 102.493 62.1193C102.493 64.7166 100.436 66.7766 97.8422 66.7766C95.3379 66.7766 93.1914 64.7166 93.1914 62.1193Z",
    fill: "#A6AAC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7407 95.885C53.0338 86.0329 62.7825 79.1365 74.1412 79.1365C85.4999 79.1365 95.3381 86.0329 99.5417 95.885",
    stroke: "#A6AAC4",
    strokeWidth: 4.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.ac86cd2909e573155c9f009afd4ebc33.svg";
export { ForwardRef as ReactComponent };